/**
 * Created by staffanrantzow on 14/06/16.
 */

import React, { PropTypes } from 'react';
import Utils from 'frilans-finans/utils/utils';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import { Link } from 'react-router';

class SalaryRow extends React.Component {

  static propTypes = {
    canGenerateSalarySpecification: PropTypes.func.isRequired,
    salary: PropTypes.object.isRequired,
    toggleSalary: PropTypes.func.isRequired,
    showSalarySpecification: PropTypes.func.isRequired
  };

  toggleSalary = () => {
    this.props.toggleSalary(this.props.salary.id);
  }

  showSalarySpecification = () => {
    this.props.showSalarySpecification([this.props.salary.id]);
  }

  canGenerateSalarySpecification = (salary) => {
    this.props.canGenerateSalarySpecification(salary);
  }

  renderOrderNumber = (salary) => {
    return (
      <td className='col-ordernr'>
        <Link
          to={'/economy/invoices/' + salary.invoiceId}>{salary.invoiceId}
        </Link>
      </td>
    );
  }

  renderDownloadSalarySpecification = (salary) => {
    if (this.canGenerateSalarySpecification(salary)) {
      return (
        <div>
          <span>
            {Math.round(salary.toPayIncTaxAgencyPart())} {proxyCounterpart('DEFAULT_CURRENCY_NAME_SHORT_OTHER')}
          </span>
          <a className='printer-link' onClick={this.showSalarySpecification} target='_blank' />
        </div>
      );
    }
    return <div></div>;
  }

  render = () => {
    let s = this.props.salary;
    let firstWorkDate = s.invoiceDates[0] ? Utils.formatDate(s.invoiceDates[0].date) : '';

    return (
      <tr>
        <td className='col-check'>
          <input id={'salary-' + s.id} type='checkbox'
            checked={s.selected} onClick={this.toggleSalary}
            name={'salary-' + s.id} />
          <label htmlFor={'salary-' + s.id}><span></span></label>
        </td>
        <td className='col-customer'>
          <span className='customer-name'>
            {s.typeId === 2 ? `${s.companyName} (${proxyCounterpart('VACATION_MONEY')})` : s.companyName}
          </span>
        </td>
        {this.renderOrderNumber(s)}
        <td className='col-pay-id'>{s.id}</td>
        <td className='col-date'>{firstWorkDate}</td>
        <td className='col-pay-sum'>
          {this.renderDownloadSalarySpecification(s)}
        </td>
        <td className='col-pay-date'>{Utils.formatDate(s.paidAt)}</td>
        <td className='col-in-links'>
          <a className='printer-link' onClick={this.showSalarySpecification} target='_blank' />
        </td>
      </tr>
    );
  }

}

export default SalaryRow;



/** WEBPACK FOOTER **
 ** ./src/views/economy-view/salaries/salary-row.js
 **/